export const colors = {
    white: '#FFF',
    red: '#EF4444',
    red300: '#FECACA',
    red600: '#DC2626',
    orange: '#F97316',
    orange300: '#FED7AA',
    orange600: '#EA580C',
    yellow: '#EAB308',
    green: '#22C55E',
    green300: '#A7F3D0',
    green600: '#16A34A',
    black: '#0A0A0A',
    grey200: '#F5F5F5',
    grey300: '#E3E3E3',
    grey400: '#c5c5c5',
    grey600: '#939393',
    grey800: '#2e2e2e',
    lightGrey: '#F6F6F6',
    keyBackground: '#F5EEFF',
    keyHover: '#E1CAFF',
    key: '#9747FF',
    keyDarker: '#7E3BD6',
    keyDarkest: '#662FAE',
    blue: '#D8EAFF',
    infoBlue: '#001FC1'
}